import React, { Component } from 'react';
import { Card, Icon, Image } from 'semantic-ui-react';

class FileUploadButton extends Component {
  constructor(props) {
    super(props);

    const hasThumbnail =
      typeof props.image === 'string' && props.image.length > 0;
    let extension = null;

    if (hasThumbnail) {
      const url = props.image.replace(/(\?t=[0-9]+)+/, '');
      extension = url.split('.').pop();
    }

    this.state = {
      hasThumbnail,
      image: props.image,
      extension: extension,
      extImages: ['png', 'jpeg', 'jpg', 'gif'],
      extAudios: ['mp3'],
      extVideos: ['mp4'],
    };
  }

  handleChange(e) {
    const files = e.target.files;

    if (files && files[0]) {
      const file = files[0];
      const ext = file.name
        .replace(/(\?t=[0-9]+)+/, '')
        .split('.')
        .pop();
      if (this.state.extImages.indexOf(ext) !== -1) {
        var reader = new FileReader();

        reader.onload = (e) => {
          this.setState({
            hasThumbnail: true,
            image: e.target.result,
            extension: ext,
          });
        };

        reader.readAsDataURL(file);
      } else if (
        this.state.extAudios.indexOf(ext) !== -1 ||
        this.state.extVideos.indexOf(ext) !== -1
      ) {
        const src = URL.createObjectURL(file);
        this.setState({
          hasThumbnail: true,
          image: src,
          extension: ext,
        });
      }
    }

    this.props.onChange(e);
  }

  render() {
    const { id, label } = this.props;
    const { hasThumbnail, image, extension } = this.state;
    const labelAttrs = { htmlFor: id };
    const inputAttrs = { id: id };

    return (
      <Card fluid>
        {hasThumbnail && this.state.extImages.indexOf(extension) !== -1 && (
          <Image src={image} />
        )}
        {hasThumbnail && this.state.extVideos.indexOf(extension) !== -1 && (
          <video controls>
            <source src={image} type="video/mp4" />
          </video>
        )}
        {hasThumbnail && this.state.extAudios.indexOf(extension) !== -1 && (
          <audio
            src={image}
            controls
            style={{ width: '100%', background: 'lightgray' }}
          ></audio>
        )}
        <Card.Content>
          <label {...labelAttrs} className="ui icon button fluid">
            <Icon name="upload" /> {label}
          </label>
          <input
            type="file"
            {...inputAttrs}
            style={{ display: 'none' }}
            onChange={(e) => this.handleChange(e)}
          />
        </Card.Content>
      </Card>
    );
  }
}

export default FileUploadButton;



// WEBPACK FOOTER //
// ./src/components/fileUploadButton.js